import { simplifiedPosition } from './data';

// Mutates the strategy (also works with an Immer draft). Preserve both pitch
// players when moving onto an occupied position; bench replacements stay one-way.
// `locked` holds the ids of starters who must stay in the XI (sent off in the
// running match): they may change slot, but a bench player may not take theirs.
export function replaceStrategyPlayer(strategy, player, locked = new Set()) {
  const position = strategy.selectedPlayer.type;
  if (!player?._id || !position) return;
  const incoming = strategy.allTeam.find((item) => item._id === player._id);
  if (!incoming) return;
  const source = strategy.majorStaff.findIndex((item) => item._id === player._id);
  const target = strategy.majorStaff.findIndex(
    (item) => item.current_position === position
  );
  if (source >= 0 && source === target) return;
  const previous = target >= 0 ? strategy.majorStaff[target] : null;
  // A bench player taking a locked starter's slot would bench him; the API refuses
  // that lineup with 403. A starter swapping with him keeps both in the XI.
  if (source < 0 && previous && locked.has(String(previous._id))) return;
  const origin = source >= 0 ? strategy.majorStaff[source].current_position : null;
  const replacement = { ...incoming, current_position: position, main: true };
  if (source >= 0 && previous) {
    strategy.majorStaff[source] = { ...previous, current_position: origin, main: true };
    strategy.majorStaff[target] = replacement;
  } else {
    if (source >= 0) strategy.majorStaff.splice(source, 1);
    const targetIndex = strategy.majorStaff.findIndex(
      (item) => item.current_position === position
    );
    if (targetIndex >= 0) strategy.majorStaff[targetIndex] = replacement;
    else strategy.majorStaff.push(replacement);
  }
  const ids = new Set(strategy.majorStaff.map((item) => item._id));
  strategy.allTeam.forEach((item) => {
    item.main = ids.has(item._id);
  });
  strategy.selectedPlayer.index = strategy.majorStaff.findIndex(
    (item) => item._id === player._id
  );
}

// A formation change keeps majorStaff as it is, and the save sends only the
// players on the new formation's slots. A locked starter left on a slot the new
// formation lacks would be dropped from the save. Move him onto a free slot
// (same line first). With every slot taken, he trades places with an unlocked
// starter, who is then left off the pitch as anyone on a removed slot is today.
export function keepLockedInFormation(strategy, slots, locked) {
  if (!locked?.size || !slots?.length) return;
  const holder = (slot) => strategy.majorStaff.findIndex((item) => item.current_position === slot);
  strategy.majorStaff.forEach((player, index) => {
    if (!locked.has(String(player._id)) || slots.includes(player.current_position)) return;
    const line = simplifiedPosition[player.current_position];
    const pick = (list) => list.find((slot) => simplifiedPosition[slot] === line) || list[0];
    const free = slots.filter((slot) => holder(slot) < 0);
    const tradable = slots.filter(
      (slot) => holder(slot) >= 0 && !locked.has(String(strategy.majorStaff[holder(slot)]._id))
    );
    const slot = pick(free) || pick(tradable);
    if (!slot) return;
    const other = holder(slot);
    if (other >= 0) {
      strategy.majorStaff[other] = { ...strategy.majorStaff[other], current_position: player.current_position };
    }
    strategy.majorStaff[index] = { ...player, current_position: slot };
  });
}
